import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Popconfirm,Popover,
  Collapse,Avatar,Drawer,Descriptions,message,Modal,Spin,Switch} from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,FundOutlined,FundViewOutlined,DeleteOutlined,LockFilled,LockOutlined,LoadingOutlined } from '@ant-design/icons';
import { UserOutlined } from '@ant-design/icons';
import { Form,Select,Checkbox,Upload } from 'antd';
import { Link } from 'react-router-dom';
import * as serverconfig from '../../serverconn'
import UserCreationForm from '../components/UserCreationForm'

var CryptoJS = require("crypto-js");
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const { Panel } = Collapse;
const FormItem=Form.Item;

function callback(key) {
  console.log(key);
}

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});

var token= ''

class AccountList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    accounts: [],
    rightsmodalvisible:false,
    rights: {},
    selectedid:'',
    datarequested:true,

    view_statistics:true,
    view_product_orders:true,
    view_umoja_deliveries:true,

    view_online_riders:true,
    view_agent_activities:true,

    view_barcodes:true,
    create_barcodes:true,

    //new pending Umoja pickups rights
    view_pending_umoja_pickups:true,
    create_update_pending_umoja_pickups:true,

    can_enter_newcase:true,
    can_edit_case:true,
    can_view_allcases:true,

    can_create_patient_reviews:true,
    can_edit_patient_reviews:true,
    can_view_patient_reviews:true,
    
    can_assign_cases:true,
    can_create_case_review:true,
    can_view_case_reviews:true,

   
  };

  displaypasswordupdatemodal=(id)=>{
    this.setState({showpasswordupdatemodal:true})
    this.setState({selectedid:id})
  }
  
  closepasswordupdatemodal=()=>{
    this.setState({showpasswordupdatemodal:false})
  }
  
  //////////////////////////////////////
  ///// change password here
  handlePasswordChange=(values)=>{
    this.setState({datarequested:true})

    let form_data = new FormData();
    form_data.append('password1', values.new_password1);
    form_data.append('password2', values.new_password2);
    form_data.append('userid', this.state.selectedid);
  
    //Now send the post resquest
      axios.post(serverconfig.backendserverurl+'/customqueries/updatecompanyuserpassword', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
    .then(res => {
      this.setState({datarequested:false})

      message.info(res.data.message);
    }
    )
    .catch(error => console.log(error)) 
  
  }




  ///////////////////////////////////////////
  //getting simple user account rights
  showAccountRights=(text) =>{
    this.setState({ rightsmodalvisible: true });

    //make api call to get the user rights
    axios.get(`${serverconfig.backendserverurl}/api/accountrights?user=${text}`)
    .then(res => {  
        this.setState({
            rights: res.data[0]
        })
        this.setState({view_statistics:res.data[0].view_statistics})
        this.setState({view_product_orders:res.data[0].view_product_orders})
        this.setState({view_umoja_deliveries:res.data[0].view_umoja_deliveries})

        this.setState({view_online_riders:res.data[0].view_online_riders})
        this.setState({view_agent_activities:res.data[0].view_agent_activities})

        this.setState({view_barcodes:res.data[0].view_barcodes})
        this.setState({create_barcodes:res.data[0].create_barcodes})

        this.setState({view_pending_umoja_pickups:res.data[0].view_pending_umoja_pickups})
        this.setState({create_update_pending_umoja_pickups:res.data[0].create_update_pending_umoja_pickups})

    })

  }

  //////////////////////////////////////////////////
  //handle delete here
  handleDelete = id => {
    axios.delete(`${serverconfig.backendserverurl}/api/accounts/${id}`).then(res =>{
      window.location.reload(false)
      message.info("successfully deleted") 
     }
     );
  };



  //make an update now on the user rights

  componentDidMount(){

    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    axios.get(serverconfig.backendserverurl+`/api/accounts/`)
    .then(res => {
        this.setState({
          accounts:res.data
        })

        this.setState({datarequested:false})

    })

}


  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {
    
    const columns = [
      {
        title: 'Profile',
        dataIndex: 'profile_pic',
        key: 'profile_pic',
        render: (text,record) => <Avatar
        size={60}
        icon={<UserOutlined />}
        alt="User Pic"
        src={record.profile_pic}
        />,

      },
      
      {
        title: 'User Name',
        dataIndex: 'username',
        key: 'id',
        ...this.getColumnSearchProps('username'),
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'id',
      },

      {
        title: 'Coodinated hub (Hub manager)',
        dataIndex: 'coodinated_hub_name',
        key: 'id',
      },

      {
        title: 'Actions',
        dataIndex: 'id',
        key: 'id',
        render: text =>
        <p>
        <Popover content={<p>Click here to edit,view details</p>} title="Edit,View">
         <Link to={`/useraccounts/${text}`}><FundViewOutlined style={{color:'blue'}}/></Link>
        </Popover>
        &nbsp;&nbsp;&nbsp;
        <Popover content={<p>Click here to edit,view user rights</p>} title="Edit,View rights">
         <UserOutlined onClick={(event) => this.showAccountRights(text)} style={{color:'blue'}}/>
        </Popover>

        &nbsp;&nbsp;&nbsp;
        <Popover content={<p>Click to change password</p>} title="Password Change">
          <LockFilled style={{color:'#154360'}} onClick={() => this.displaypasswordupdatemodal(text)}/>
        </Popover>
        </p>,
      },

    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin  size="large">
                <div className="content" />
              </Spin>       
        </div>
      )

    }else{

      return(
        <div>
           <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header="ALL ACCOUNTS" key="1">
            <Table 
             scroll={{ x: 1000 }}
             columns={columns}
             pagination={{showQuickJumper:true,showSizeChanger:true }}
             dataSource={this.state.accounts} bordered/>
            </Panel>
            </Collapse>
            <br></br>
            <UserCreationForm />
            <br></br>

            <Drawer
                title={this.state.rights.username+" "+"Account Rights"}
                width={520}
                placement="right"
                closable={false}
                onClose={
                  () => {
                    this.setState({ rightsmodalvisible: false });
                  }
                }
                visible={this.state.rightsmodalvisible}
              >
  
                    <h3 style={{color:'red'}}>Edit User Rights</h3>

                    <Form  
                      onFinish={
                        (values)=>{
                          let form_data = new FormData();
                      
                          form_data.append('view_statistics', this.state.view_statistics)
                          form_data.append('view_product_orders', this.state.view_product_orders)
                          form_data.append('view_umoja_deliveries', this.state.view_umoja_deliveries)
                      
                          form_data.append('view_online_riders', this.state.view_online_riders)
                          form_data.append('view_agent_activities', this.state.view_agent_activities)
                      
                          form_data.append('view_barcodes', this.state.view_barcodes)
                          form_data.append('create_barcodes', this.state.create_barcodes)

                          form_data.append('view_pending_umoja_pickups', this.state.view_pending_umoja_pickups)
                          form_data.append('create_update_pending_umoja_pickups', this.state.create_update_pending_umoja_pickups)
                      
                      
                          //Now send the post resquest
                          axios.put(`${serverconfig.backendserverurl}/api/accountrights/${this.state.rights.id}/`, form_data, {
                            headers: {
                              'content-type': 'multipart/form-data'
                            }
                            })
                          .then(res => window.location.reload(false)
                          )
                          .catch(error => console.log(error))
                      
                        }
                      }        
                      >
                      <FormItem name="view_statistics" label="view_statistics" >
                          <Switch
                              checked={this.state.view_statistics}
                              onChange={(val)=>{this.setState({view_statistics:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem>  

                      <FormItem name="view_umoja_deliveries" label="view_umoja_deliveries" >
                          <Switch
                              checked={this.state.view_umoja_deliveries}
                              onChange={(val)=>{this.setState({view_umoja_deliveries:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 

                      <FormItem name="view_product_orders" label="view_product_orders" >
                          <Switch
                              checked={this.state.view_product_orders}
                              onChange={(val)=>{this.setState({view_product_orders:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 
                      

                      <FormItem name="view_online_riders" label="view_online_riders" >
                          <Switch
                              checked={this.state.view_online_riders}
                              onChange={(val)=>{this.setState({view_online_riders:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 

                      <FormItem name="view_agent_activities" label="view_agent_activities" >
                          <Switch
                              checked={this.state.view_agent_activities}
                              onChange={(val)=>{this.setState({view_agent_activities:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 

                      <FormItem name="view_barcodes" label="view_barcodes" >
                          <Switch
                              checked={this.state.view_barcodes}
                              onChange={(val)=>{this.setState({view_barcodes:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 

                      <FormItem name="create_barcodes" label="create_barcodes" >
                          <Switch
                              checked={this.state.create_barcodes}
                              onChange={(val)=>{this.setState({create_barcodes:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 

                      <FormItem name="view_pending_umoja_pickups" label="view_pending_umoja_pickups" >
                          <Switch
                              checked={this.state.view_pending_umoja_pickups}
                              onChange={(val)=>{this.setState({view_pending_umoja_pickups:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 

                      <FormItem name="create_update_pending_umoja_pickups" label="create_update_pending_umoja_pickups" >
                          <Switch
                              checked={this.state.create_update_pending_umoja_pickups}
                              onChange={(val)=>{this.setState({create_update_pending_umoja_pickups:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 


                        <FormItem>
                          <Button htmlType="submit" type="primary">Update</Button>
                        </FormItem>
                        
                      </Form>

              </Drawer>


              <Modal              
                visible={this.state.showpasswordupdatemodal}
                title="Password change Form"
                width={600}
                onCancel={this.closepasswordupdatemodal}

                footer={[
                  <Button key="back" onClick={this.closepasswordupdatemodal}>
                    Cancel
                  </Button>
                  ]}
                  >
              <Form
              onFinish={this.handlePasswordChange}        
              name="passwordreset"
              className="login-form">
        
              <Form.Item
                  name="new_password1"
                  label="New Password one"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your password!',
                    },
                  ]}
                  hasFeedback
                >
                  <Input.Password 
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="Password one"
                  />


                </Form.Item>

          
                <Form.Item
                  name="new_password2"
                  label="Confirm New Password"
                  dependencies={['new_password1']}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Please confirm your password!',
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue('new_password1') === value) {
                          return Promise.resolve();
                        }
          
                        return Promise.reject('The two passwords that you entered do not match!');
                      },
                    }),
                  ]}
                >
                  <Input.Password 
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="Confirm" />

                </Form.Item>

              <Form.Item >
                  <Button type="primary" htmlType="submit" className="login-form-button">
                    Confirm Change
                  </Button>
              </Form.Item>
            </Form>
                    
            </Modal>


            
        </div>
    )
    }
   
  }
}

export default AccountList; 
